import styled from 'styled-components';
import device from '../../mediaQueries';

const BrowseText = styled.div`
  max-width: 948px;
  font-weight: 300;
  font-size: 15px;
  ${device.mobile`
    margin: 0 38px;
  `}
  ${device.desktop`
    margin: auto;
  `}
  > *,
  > * > * {
    font-size: 15px;
  }
`;

export default BrowseText;
